var isRequest = false;

function loadMoreProducts() {
  if (isRequest) return;

  // Get fresh references to elements and data-next-url each time
  var productsOnPage = document.querySelector(".products-on-page");
  var loadMoreBtn = document.querySelector(".load-more_btn");
  var loadMoreSpinner = document.querySelector(".load-more_spinner");
  var nextUrl = productsOnPage
    ? productsOnPage.getAttribute("data-next-url")
    : null;

  if (!nextUrl || !productsOnPage || !loadMoreBtn || !loadMoreSpinner) {
    console.warn("Load more: Missing required elements or next URL");
    return;
  }

  var xhr = new XMLHttpRequest();
  xhr.open("GET", nextUrl, true);
  xhr.setRequestHeader("Content-Type", "text/html");

  xhr.onloadstart = function () {
    isRequest = true;
    loadMoreBtn.disabled = true;
    loadMoreBtn.style.display = "none";
    loadMoreSpinner.style.display = "block";
  };

  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 400) {
      loadMoreSpinner.style.display = "none";

      var tempDiv = document.createElement("div");
      tempDiv.innerHTML = xhr.responseText;

      var newProducts = tempDiv.querySelector(".products-on-page");
      var newUrl = newProducts
        ? newProducts.getAttribute("data-next-url")
        : null;

      // Update the data-next-url attribute on the existing products container
      if (newUrl) {
        productsOnPage.setAttribute("data-next-url", newUrl);
        loadMoreBtn.style.display = "block";
      } else {
        // No more pages, hide the load more button
        productsOnPage.removeAttribute("data-next-url");
        loadMoreBtn.parentElement.style.display = "none";
      }

      if (newProducts) {
        productsOnPage.insertAdjacentHTML("beforeend", newProducts.innerHTML);
      }

      // wishlist plus adding hearts on newly loaded products
      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
    }
    isRequest = false;
  };

  xhr.onerror = function () {
    isRequest = false;
    loadMoreSpinner.style.display = "none";
    loadMoreBtn.style.display = "block";
    loadMoreBtn.disabled = false;
  };

  xhr.send();
}

// Use event delegation to handle clicks on the load more button
// This ensures the event listener works even after DOM updates from filtering
document.addEventListener("click", function (e) {
  if (e.target && e.target.classList.contains("load-more_btn")) {
    e.preventDefault();
    loadMoreProducts();
  }
});
